/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryModifierAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class QueryModifierAPI {

		/**
		 * @function QueryModifierAPI#modifyQuerySpecList
		 * @description modify the given query spec list
		 * @public
		 * @param querySpecList query spec list returned from queryProvider
		 * @return {Object[]} modified query spec list
		 */
		modifyQuerySpecList() {}

		/**
		 * @return {String} the type of the modifier
		 */
		getType(){}
	}
	return QueryModifierAPI;
});
